export default __webpack_public_path__ + "static/icon-tile-light-2fd0cfccbb2df9cde2e105569b58a4932f16be188281e968670cfe6b8da63031.png";